"use client"

import {useSearchParams} from "next/navigation";
import {signIn} from "@/api/core/actions/auth/signIn";
import {isSuccessResult} from "@/components/form/utils";
import {SignInData} from "../sign-in-schema";
import {Login} from "./login";

export function LoginWrapper() {
  const searchParams = useSearchParams();
  const cancelUrl = searchParams.get("cancelUrl") ?? undefined;

  const handleEmailLogin = async (data: SignInData) => {
    const result = await signIn(data)
    if (isSuccessResult(result)) {
      const callbackUrl = searchParams.get("callbackUrl");
      // Only allow relative URLs to prevent open redirect
      const destination = callbackUrl?.startsWith("/") ? callbackUrl : result.success.redirectUrl;
      window.location.href = destination;
    }
    return result
  }
  return (
    <Login handleEmailLogin={handleEmailLogin} cancelUrl={cancelUrl}/>
  )
}
